module.exports = __webpack_public_path__ + "img/secret_four.6351e0af.png";